import * as types from './mutation-types'

export const changeBot = ({ commit }, data) => {
  commit(types.CHANGEBOT, data)
}
export const changeMsgreply = ({ commit }, data) => {
  commit(types.CHANGEMSGREPLY, data)
}
export const changeReply = ({ commit }, data) => {
  commit(types.CHANGEREPLY, data)
}
export const changeFriend = ({ commit }, data) => {
  commit(types.CHANGEFRIEND, data)
}
export const myProfile = ({ commit }, data) => {
  commit(types.MYPROFILE, data)
}
export const showMember = ({ commit }, data) => {
  commit(types.SHOWMEMBER, data)
}
export const myName = ({ commit }, data) => {
  commit(types.MYNAME, data)
}
export const changeGroup = ({ commit }, data) => {
  commit(types.CHANGEGROUP, data)
}
export const changeGroupMember = ({ commit }, data) => {
  commit(types.CHANGEGROUPMEMBER, data)
}
export const changeRightTool = ({ commit }, data) => {
  commit(types.CHANGERIGHTTOOL, data)
}
export const sendRequest = ({ commit }, data) => {
  commit(types.SENDREQUEST, data)
}
export const listsendRequest = ({ commit }, data) => {
  commit(types.LISTSENDREQUEST, data)
}
export const Request = ({ commit }, data) => {
  commit(types.REQUEST, data)
}
export const listRequest = ({ commit }, data) => {
  commit(types.LISTREQUEST, data)
}
export const listFriend = ({ commit }, data) => {
  commit(types.LISTFRIEND, data)
}
export const listChat = ({ commit }, data) => {
  commit(types.LISTCHAT, data)
}
export const groupReq = ({ commit }, data) => {
  commit(types.GROUPREQ, data)
}
export const listgroupReq = ({ commit }, data) => {
  commit(types.LISTGROUPREQ, data)
}
export const listGroup = ({ commit }, data) => {
  commit(types.LISTGROUP, data)
}
export const tokenRoom = ({ commit }, data) => {
  commit(types.TOKENROOM, data)
}
export const groupidRemove = ({ commit }, data) => {
  commit(types.GROUPIDREMOVE, data)
}
export const chatFile = ({ commit }, data) => {
  commit(types.CHATFILE, data)
}
export const chatImage = ({ commit }, data) => {
  commit(types.CHATIMAGE, data)
}
export const listbot = ({ commit }, data) => {
  commit(types.LISTBOT, data)
}



// WEBPACK FOOTER //
// ./src/store/action.js